import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-telefone2',
  templateUrl: './text-telefone2.component.html',
  styleUrls: ['./text-telefone2.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextTelefone2Component implements OnInit {

  constructor() {}

  ngOnInit() {}

}
